import styled from "styled-components";
import {
  Table,
  TdContainer,
  ThContainer,
  Tr,
} from "../../../../../components/Table/Table";
import TouchableText from "../../../../../components/TouchableText";
import { Colors } from "../../../../../constants";
import { PreOrderStatusEnum } from "../../../../../constants/PreOrderStatus";

export const colorsByStatus = {
  [PreOrderStatusEnum.PENDING_APPROVAL]: Colors.WARNING_SHADES_MAIN,
  [PreOrderStatusEnum.APPROVED]: Colors.SUCCESS_LIGHT,
  [PreOrderStatusEnum.CANCELED]: Colors.DANGER,
};

export const backgroundColorByStatus = {
  [PreOrderStatusEnum.PENDING_APPROVAL]: Colors.WARNING_LIGHT,
  [PreOrderStatusEnum.APPROVED]: Colors.SUCCESS_LIGHT_SHADE,
  [PreOrderStatusEnum.CANCELED]: Colors.RED_LIGHT,
};

export const StyledTable = styled(Table)`
  & ${ThContainer} {
    height: 56px;
    display: flex;
    align-items: center;
    background-color: transparent;
    ${({ haspadding }) =>
      haspadding &&
      `
      padding-right: 32px;
    `};
  }

  & ${TdContainer} {
    height: 56px;
    display: flex;
    align-items: center;
    ${({ haspadding }) =>
      haspadding &&
      `
      padding-right: 32px;
    `};
  }
`;

export const StyledRowWrapper = styled(Tr)`
  ${({ isExpanded }) =>
    isExpanded &&
    `
  border-style: solid;
  border-color: ${Colors.SECONDARY_MEDIUM_SHADE};
  border-width: 1px 1px 0 1px;
  `}
`;

export const ProductsContainer = styled.div`
  background-color: #f8f9fa;
  border-top: 1px solid #e0e0e0;
`;

export const ProductsHeader = styled.div`
  display: grid;
  grid-template-columns: 1.22fr 1fr;
  align-items: center;
  padding: 15px 16px;
  background-color: ${Colors.PRIMARY_BLUE_SHADE};
`;

export const ProductsTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin-left: 48px;
  ${({ quantity }) =>
    quantity &&
    `
    margin-left: 0px;
  `};
`;

export const ProductItem = styled.div`
  display: grid;
  grid-template-columns: 1.22fr 1fr;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  background-color: ${Colors.PRIMARY_BLUE_SHADE_LIGHT};
`;

export const ProductName = styled.span`
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin-left: 64px;
`;

export const ProductQuantity = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin-left: 0px;
`;

export const StyledTouchableText = styled(TouchableText)`
  color: ${Colors.WHITE};
  font-size: 12px;
  margin-left: 24px;
`;

export const StyledStatusContainer = styled.div`
  background-color: ${({ status }) =>
    backgroundColorByStatus[status] || Colors.GRAY_LIGHT};
  color: ${({ status }) => colorsByStatus[status] || Colors.GRAY_DARK};
  border: 1px solid
    ${({ status }) => colorsByStatus[status] || Colors.GRAY_DARK};
  border-radius: 16px;
  padding: 4px 8px;
  margin-left: -16px;
`;

export const StyledStatusText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: ${({ status }) => colorsByStatus[status] || Colors.GRAY_DARK};
`;
